import React from "react";
import local from "../../../localization/strings";
import MaterialTable from "material-table";
import { tableIcons } from "../../../helpers/tableIcons";
import { getSquirrelRangeType } from "../../../helpers/utils";
import moment from "moment";

const LoggerChannelHistory = ({ channelHistory }) => {
	const columns = [
		{
			field: "dateInserted",
			title: local.TF_DateTimeUtc,
			render: (rowData) => <div className="text-nowrap">{moment(rowData.dateInserted).format("DD MMM YY HH:mm")}</div>,
			defaultSort: "desc",
		},
		{
			field: "channelNumber",
			title: local.TF_Channel_Number,
			render: (rowData) => <div>{rowData.channelNumber + 1}</div>,
		}, //
		{ field: "identity", title: local.TS_Name, render: (rowData) => <div>{rowData.identity}</div> },
		{
			field: "DF_1",
			title: local.TF_Input,
			render: (rowData) => (
				<>
					<div>{getSquirrelRangeType(rowData.rangeType)}</div>
					{rowData.log ?? true ? "" : <div className="text-danger">{local.TF_OFF}</div>}
				</>
			),
		},
		{ field: "DF_2", title: local.TS_Range, render: (rowData) => <div>{rowData.rangeString}</div> },
		{ field: "DF_3", title: local.TS_Units, render: (rowData) => <div>{rowData.rangeUnits}</div> },
		{ field: "highStart", title: local.TF_High_Start, render: (rowData) => <div>{rowData.highStartScaled}</div> },
		{ field: "lowStart", title: local.TF_Low_Start, render: (rowData) => <div>{rowData.lowStartScaled}</div> },
		{ field: "alarmDelay", title: local.TF_Delay, render: (rowData) => rowData.alarmDelay !== 0 && <div>{rowData.alarmDelayTime}</div> },
		{ field: "smsGroup", title: local.TF_Group_Name, render: (rowData) => rowData.smsGroup },
		{ field: "transmitterSerialNumber", title: local.TF_TransmitterSerialNumber, render: (rowData) => rowData.transmitterSerialNumber && rowData.transmitterSerialNumber !== "0" && <div>{rowData.transmitterSerialNumber}</div> },
		{ field: "transmitterChannelNumber", title: local.TF_Transmitter_Channel, render: (rowData) => <div>{rowData.transmitterSerialNumber && rowData.transmitterSerialNumber !== "0" ? String.fromCharCode(65 + rowData.transmitterChannelNumber) : ""}</div> },
		{ field: "username", title: local.TF_Username, render: (rowData) => <div>{rowData.username}</div> },
	];
	return <>{channelHistory.length > 0 && <MaterialTable columns={columns} data={channelHistory} title="" icons={tableIcons} options={{ exportButton: true, exportAllData: true, exportFileName: "Export", search: true, sorting: true, paging: true, pageSize: 20, pageSizeOptions: [20, 50, 100], emptyRowsWhenPaging: false, showEmptyDataSourceMessage: false, headerStyle: { backgroundColor: "#edf2f9", color: "#01579b" } }} />}</>;
};

export default LoggerChannelHistory;
